const configurations: { [env: string]: any } = {
    test: {
        host: "https://test-meta.tnworld.cn/tn-api/",
        mode: "test",
        projects: ["qinghuaci"]
    },
    production: {
        host: "https://meta.tnworld.cn/tn-api/",
        mode: "production",
        projects: ["qinghuaci"]
    },
}


export default configurations[process.env.REACT_APP_HOST_TYPE ?? "test"]